import React, { useEffect, useState } from 'react';
import AddDataModal from "./AddDataModal";
import EditDataModal from "./EditDataModal";
import HistoryModal from "./HistoryModal";
import Paginator from "../../components/common/Paginator/Paginator";

const Sales = React.memo(({ salesList, getSalesTh, filters = {}, applySalesFiltersTh, resetSalesFiltersTh, ...props }) => {
    const [localFilters, setLocalFilters] = useState({ ...filters });

    useEffect(() => {
        setLocalFilters({ ...filters });
    }, [filters]);

    // Paginator üçün təhlükəsiz callback — həmişə funksiya olacaq
    const handlePageChange = (page, size) => {
        if (typeof getSalesTh === 'function') {
            getSalesTh(page, size, localFilters);
        } else if (typeof props.getSalesTh === 'function') {
            props.getSalesTh(page, size, localFilters);
        } else {
            console.warn('Sales: getSalesTh tapılmadı', { getSalesTh, propsGetSalesTh: props.getSalesTh });
        }
    };

    const handleFilterChange = (key, value) => {
        setLocalFilters(prev => ({ ...prev, [key]: value }));
    };

    const handleSearch = () => {
        if (typeof applySalesFiltersTh === 'function') {
            applySalesFiltersTh(localFilters);
        } else if (typeof getSalesTh === 'function') {
            getSalesTh(0, localFilters.size || 10, localFilters);
        }
    };

    const handleReset = () => {
        if (typeof resetSalesFiltersTh === 'function') {
            resetSalesFiltersTh();
        }
    };

    const statusLabel = (paymentStatus) => {
        switch (paymentStatus) {
            case 0: return <span className="badge badge-pill badge-warning">⏳ Gözləmədə</span>;
            case 1: return <span className="badge badge-pill badge-success">✅ Uğurlu</span>;
            case 2: return <span className="badge badge-pill badge-danger">❌ Uğursuz</span>;
            default: return <span className="badge badge-pill badge-secondary">?</span>;
        }
    };

    const [refreshingId, setRefreshingId] = useState(null);
    const [bulkLoading, setBulkLoading] = useState(false);
    const [historySaleId, setHistorySaleId] = useState(null);
    const [showHistory, setShowHistory] = useState(false);

    const handleRefreshRow = (saleId) => {
        if (typeof props.refreshStatusTh !== 'function') return;
        setRefreshingId(saleId);
        Promise.resolve(props.refreshStatusTh(saleId)).finally(() => setRefreshingId(null));
    };

    const handleRefreshPending = () => {
        if (typeof props.refreshPendingTh !== 'function') return;
        setBulkLoading(true);
        Promise.resolve(props.refreshPendingTh(7)).finally(() => setBulkLoading(false));
    };

    const handleOpenHistory = (saleId) => {
        setHistorySaleId(saleId);
        setShowHistory(true);
    };

    const formatDate = (value) => {
        if (!value) return '—';
        const d = new Date(value);
        return isNaN(d.getTime()) ? value : d.toLocaleString('az-AZ');
    };
    let [isEditSales, setIsEditSales] = useState(false);
    let [isCreateSales, setIsCreateSales] = useState(false);
    let [saleId, setSalesId] = useState();
    const [show, setShow] = useState(false);

    useEffect(() => {
        if (isCreateSales) setShow(isCreateSales);
    }, [isCreateSales]);

    useEffect(() => {
        if (isEditSales) setShow(isEditSales);
    }, [isEditSales]);

    const EditSales = (event) => {
        setSalesId(event.target.id);
        setIsEditSales(true);
    };

    const AddSales = () => {
        setIsCreateSales(true);
    };

    // Optional chaining (?.) əlavə olundu ki, crash verməsin
    let salesListList = salesList?.map(sale => (
        <tr key={sale.id}>
            <td>{sale.id}</td>
            <td>{sale.fullName}</td>
            <td>{sale.mobile}</td>
            <td>{sale.profession}</td>
            <td>{sale.jobName}</td>
            <td>{sale.jobPosition}</td>
            <td>{sale.serialNumber}</td>
            <td>{sale.fin_code}</td>
            <td>{sale.email}</td>
            <td>{statusLabel(sale.paymentStatus)}</td>
            <td style={{ width: "80px" }}>{sale.price ?? '—'}</td>
            <td>{formatDate(sale.orderDate || sale.created_at)}</td>
            <td>{formatDate(sale.paid_at || sale.updated_at || sale.payment_date)}</td>
            <td>
                <button
                    type="button"
                    className="btn btn-sm btn-outline-primary mr-1"
                    disabled={!sale.kapitalOrderId || refreshingId === sale.id}
                    onClick={() => handleRefreshRow(sale.id)}
                    title={!sale.kapitalOrderId ? "kapitalOrderId yoxdur" : "Bankdan yenidən yoxla"}
                >
                    {refreshingId === sale.id ? '⏳' : '🔄'} Yenidən yoxla
                </button>
                <button
                    type="button"
                    className="btn btn-sm btn-outline-secondary"
                    onClick={() => handleOpenHistory(sale.id)}
                >
                    📋 Tarixçə
                </button>
            </td>
        </tr>
    ));

    return (
        <div>
            {isCreateSales &&
            <AddDataModal
                show={isCreateSales}
                sale={salesList}
                addSalesTh={props.addSalesTh}
                setIsCreateSales={setIsCreateSales}
                {...props}
            />
            }
            {isEditSales &&
            <EditDataModal
                show={isEditSales}
                setIsEditSales={setIsEditSales}
                saleId={saleId}
                salesList={salesList}
                updateSalesTh={props.updateSalesTh}
                deleteSalesTh={props.deleteSalesTh}
                {...props}
            />
            }
            <HistoryModal
                show={showHistory}
                onHide={() => setShowHistory(false)}
                saleId={historySaleId}
            />
            <div className="card ml-1 mr-1">
                <div className="card-header">
                    <h3 className="card-title">Satışlar</h3>
                    <div className="card-tools">
                        <button
                            type="button"
                            className="btn btn-sm btn-outline-success mr-2"
                            disabled={bulkLoading}
                            onClick={handleRefreshPending}
                        >
                            {bulkLoading ? '⏳ Yoxlanılır...' : '🔄 Gözləyənləri yoxla (son 7 gün)'}
                        </button>
                        <Paginator
                            totalElements={props.totalElements}
                            totalPages={props.totalPages}
                            size={props.size}
                            getNewPorsion={handlePageChange}
                        />
                    </div>
                </div>
                <div className="card-body">
                    {/* Axtarış sətri */}
                    <div className="row mb-3">
                        <div className="col-md-5 mb-2">
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Ad, email, telefon, FIN, order ID..."
                                value={localFilters.q || ''}
                                onChange={(e) => handleFilterChange('q', e.target.value)}
                                onKeyDown={(e) => { if (e.key === 'Enter') handleSearch(); }}
                            />
                        </div>
                        <div className="col-md-3 mb-2">
                            <select
                                className="form-control"
                                value={localFilters.paymentStatus ?? ''}
                                onChange={(e) => handleFilterChange('paymentStatus', e.target.value)}
                            >
                                <option value="">Bütün statuslar</option>
                                <option value="0">Gözləmədə</option>
                                <option value="1">Uğurlu</option>
                                <option value="2">Uğursuz</option>
                            </select>
                        </div>
                        <div className="col-md-2 mb-2">
                            <select
                                className="form-control"
                                value={localFilters.sortBy || 'id'}
                                onChange={(e) => handleFilterChange('sortBy', e.target.value)}
                            >
                                <option value="id">ID üzrə</option>
                                <option value="orderDate">Sifariş tarixi üzrə</option>
                                <option value="paid_at">Ödəniş tarixi üzrə</option>
                                <option value="price">Qiymət üzrə</option>
                            </select>
                        </div>
                        <div className="col-md-2 mb-2">
                            <select
                                className="form-control"
                                value={localFilters.sortDir || 'desc'}
                                onChange={(e) => handleFilterChange('sortDir', e.target.value)}
                            >
                                <option value="desc">Azalan</option>
                                <option value="asc">Artan</option>
                            </select>
                        </div>
                    </div>

                    {/* Tarix aralıqları */}
                    <div className="row mb-3">
                        <div className="col-md-6 mb-2">
                            <label className="mb-1 font-weight-bold">Sifariş tarixi</label>
                            <div className="input-group">
                                <input
                                    type="date"
                                    className="form-control"
                                    value={localFilters.dateFrom || ''}
                                    onChange={(e) => handleFilterChange('dateFrom', e.target.value)}
                                />
                                <div className="input-group-prepend input-group-append">
                                    <span className="input-group-text">—</span>
                                </div>
                                <input
                                    type="date"
                                    className="form-control"
                                    value={localFilters.dateTo || ''}
                                    onChange={(e) => handleFilterChange('dateTo', e.target.value)}
                                />
                            </div>
                        </div>
                        <div className="col-md-6 mb-2">
                            <label className="mb-1 font-weight-bold">Ödəniş tarixi</label>
                            <div className="input-group">
                                <input
                                    type="date"
                                    className="form-control"
                                    value={localFilters.paidFrom || ''}
                                    onChange={(e) => handleFilterChange('paidFrom', e.target.value)}
                                />
                                <div className="input-group-prepend input-group-append">
                                    <span className="input-group-text">—</span>
                                </div>
                                <input
                                    type="date"
                                    className="form-control"
                                    value={localFilters.paidTo || ''}
                                    onChange={(e) => handleFilterChange('paidTo', e.target.value)}
                                />
                            </div>
                        </div>
                    </div>

                    {/* Düymələr */}
                    <div className="row">
                        <div className="col-md-2 mb-2">
                            <button type="button" className="btn btn-primary btn-block" onClick={handleSearch}>
                                Axtar
                            </button>
                        </div>
                        <div className="col-md-2 mb-2">
                            <button type="button" className="btn btn-secondary btn-block" onClick={handleReset}>
                                Sıfırla
                            </button>
                        </div>
                    </div>
                </div>
                <div className="card-body p-0" style={{ overflowX: 'auto' }}>
                    <table className="table" style={{ whiteSpace: 'nowrap' }}>
                        <thead>
                        <tr>
                            <th style={{ width: "10px" }}>Id</th>
                            <th>Ad soyad</th>
                            <th>Telefon</th>
                            <th>İxtisas</th>
                            <th>İş yeri</th>
                            <th>Vəzifə</th>
                            <th>Şəxsiyyət vəsiqəsinin seriyası</th>
                            <th>Fin kod</th>
                            <th>Email</th>
                            <th>Status</th>
                            <th style={{ width: "80px" }}>Qiymət</th>
                            <th>Yaradılma tarixi</th>
                            <th>Ödəniş tarixi</th>
                            <th>Əməliyyatlar</th>
                        </tr>
                        </thead>
                        <tbody>
                        {salesListList && salesListList.length > 0 ? salesListList :
                            <tr><td colSpan="14" className="text-center">Məlumat yoxdur</td></tr>}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
});

export default Sales;
